import type { Person, PersonId } from '@bill/core';

interface Props {
  people: Person[];
  selected: PersonId[];
  onChange(selected: PersonId[]): void;
  /** Show a shortcut that selects the whole roster. */
  allowEveryone?: boolean;
}

/** Tappable name chips. Multi-select, one tap per person, no modal. */
export function PeoplePicker({ people, selected, onChange, allowEveryone = true }: Props): React.ReactElement {
  const set = new Set(selected);
  const everyone = people.length > 0 && people.every((person) => set.has(person.id));

  return (
    <div className="chips" role="group">
      {allowEveryone && (
        <button
          type="button"
          className={`chip${everyone ? ' on' : ''}`}
          aria-pressed={everyone}
          onClick={() => onChange(everyone ? [] : people.map((person) => person.id))}
        >
          Everyone
        </button>
      )}
      {people.map((person) => {
        const on = set.has(person.id);
        return (
          <button
            key={person.id}
            type="button"
            className={`chip${on ? ' on' : ''}`}
            aria-pressed={on}
            onClick={() =>
              onChange(on ? selected.filter((id) => id !== person.id) : [...selected, person.id])
            }
          >
            {person.name}
          </button>
        );
      })}
    </div>
  );
}
